var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3398_1066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9487 4.69763C16.9721 4.97745 16.4499 5.51044 16.1633 7.48842C16.1473 7.59949 15.9895 7.59917 15.9738 7.48802C15.6953 5.51222 15.1646 4.98889 13.1882 4.70161C13.0764 4.68537 13.0767 4.52638 13.1886 4.51052C15.1508 4.23217 15.6812 3.7036 15.9665 1.75402C15.9835 1.6374 16.149 1.63754 16.166 1.75417C16.4488 3.70428 16.981 4.22214 18.9491 4.50764C19.0601 4.52373 19.0598 4.6819 18.9487 4.69763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35296 4.69763C6.37636 4.97745 5.8542 5.51044 5.56763 7.48842C5.55158 7.59949 5.39376 7.59917 5.37811 7.48802C5.09965 5.51222 4.5689 4.98889 2.59246 4.70161C2.48072 4.68537 2.48095 4.52638 2.59283 4.51052C4.55517 4.23217 5.08552 3.7036 5.37081 1.75402C5.38782 1.6374 5.55334 1.63754 5.57028 1.75417C5.85308 3.70428 6.38527 4.22214 8.35336 4.50764C8.46446 4.52373 8.46422 4.6819 8.35296 4.69763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.303 14.495C16.8206 14.7048 16.429 15.1046 16.2141 16.588C16.202 16.6714 16.0837 16.6711 16.0719 16.5878C15.863 15.1059 15.4649 14.7134 13.9827 14.498C13.8989 14.4857 13.8991 14.3665 13.9829 14.3546C15.4546 14.1459 15.8524 13.7495 16.0663 12.2872C16.0792 12.1998 16.2033 12.1999 16.216 12.2873C16.428 13.7499 16.8271 14.1383 18.3032 14.3524C18.3866 14.3646 18.3865 14.4832 18.303 14.495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4209 7.16116C11.5429 7.24124 11.6782 7.34816 11.8148 7.48414C11.9514 7.62013 12.0587 7.75504 12.139 7.87649L10.0486 9.95877C9.92671 9.87869 9.79128 9.77186 9.65468 9.63587C9.51816 9.4998 9.41083 9.36497 9.33044 9.24352L11.4209 7.16116ZM11.6157 5.73856C11.4547 5.77062 11.2868 5.86408 11.1488 6.0014L1.15504 15.9122C0.936963 16.1294 0.82911 16.4218 0.901087 16.6428C1.0027 16.9547 1.23363 17.3172 1.56626 17.6486C1.89896 17.9799 2.26284 18.2099 2.57599 18.3112C2.65758 18.3376 2.74896 18.3398 2.84264 18.321C3.00361 18.2889 3.17157 18.1955 3.30936 18.0582L13.3032 8.14747C13.5213 7.93024 13.6291 7.63774 13.5572 7.41686C13.4556 7.10492 13.2247 6.7424 12.892 6.41111C12.5593 6.07965 12.1954 5.84971 11.8823 5.74844C11.8006 5.72203 11.7093 5.71995 11.6157 5.73856Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3398_1066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0772,
    height: 20,
    fill: "white",
    transform: "translate(0.0419922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.625ca12149de86586d219e0bc7d1a459.svg";
export { ForwardRef as ReactComponent };